import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './navbar.css';

function CustomNavbar() {
  // State to track if the navbar is expanded
  const [expanded, setExpanded] = useState(false);

  // Function to handle clicking a nav link: close navbar and scroll to top
  const handleNavLinkClick = () => {
    setExpanded(false); // Closes the navbar in mobile view
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top
  };

  return (
    <Navbar expanded={expanded} expand="lg" fixed="top" className="custom-navbar">
      <Container>
        <Navbar.Brand as={NavLink} to="/" end className="navbar-brand" onClick={handleNavLinkClick}>
          <img className="navbar-logo" src="/images/logo.jpeg" alt="DTE logo" />
          <span className="navbar-brand-text">Divine-Tech Engineering </span>
          {/* <span className="navbar-brand-tag">DTE</span> */}
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          aria-label={expanded ? 'Close navigation' : 'Open navigation'}
          onClick={() => setExpanded(expanded ? false : true)} // Toggle navbar state
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end className="nav-link" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" className="nav-link" onClick={handleNavLinkClick}>
              About Us
            </Nav.Link>
            <Nav.Link as={NavLink} to="/services" className="nav-link" onClick={handleNavLinkClick}>
              Services
            </Nav.Link>
            <Nav.Link as={NavLink} to="/projects" className="nav-link" onClick={handleNavLinkClick}>
              Projects
            </Nav.Link>
            <Nav.Link as={NavLink} to="/clients" className="nav-link" onClick={handleNavLinkClick}>
              Clients
            </Nav.Link>
            <Nav.Link as={NavLink} to="/news" className="nav-link" onClick={handleNavLinkClick}>
              News
            </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/quote" className="nav-link" onClick={handleNavLinkClick}>
              Get Quote
            </Nav.Link> */}
            <Nav.Link as={NavLink} to="/contact" className="nav-link" onClick={handleNavLinkClick}>
              Contact Us
            </Nav.Link>
            <Nav.Link as={NavLink} to="/quote" className="nav-link nav-cta" onClick={handleNavLinkClick}>
              Get Quote
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
